import React, { useState } from 'react';
import { trackPromise } from "react-promise-tracker";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import NotificationList from "src/components/NotificationsComponent/NotificationList";
import axios from "../../../axios/AxiosInterceptors";
import { onError, onSuccess } from "../../../store/actions/popupActions";
import useStyles from "../../../Styles";

const MarketNotificationList = (props) => {

    const classes = useStyles(props);
    const params = useParams();
    const dispatch = useDispatch();
    const [recipients, setRecipients] = useState({});

    const retrieveNotificationList = async (pageNumber, pageSize, orderBy, direction) => {
        let urlParams = { pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, direction: direction };
        await trackPromise(axios.get("/marketsgateway/v1/account/" + params.accountId + "/notification", { params: { ...urlParams } }).then(response => {
            if (response.data) {
                let recipients = response.data;
                if (recipients.results.length === 0) {
                    recipients.results.push({ accountId: params.accountId, emailAddress: '', sendDaGenerationOfferEmail: false, sendDaLoadOfferEmail: false, sendDaGenerationClearingEmail: false, sendDaLoadClearingEmail: false });
                }
                setRecipients({ ...recipients });
            }
        })).catch(error => {
            dispatch(onError(error.response));
        })
    }

    const saveDistributionList = async (recipients) => {
        await trackPromise(axios.post("/marketsgateway/v1/account/" + params.accountId + "/notification", JSON.stringify(recipients)).then(response => {
            let recipients = response.data;
            if (recipients.results.length === 0) {
                recipients.results.push({ accountId: params.accountId, name: '', emailAddress: '', sendDaGenerationOfferEmail: false, sendDaLoadOfferEmail: false, sendDaGenerationClearingEmail: false, sendDaLoadClearingEmail: false });
            }
            dispatch(onSuccess("Saved distribution list"));
        })).catch(error => {
            dispatch(onError(error.response));
        })
    }

    const deleteRecipients = async (deletedRecipients) => {
        await trackPromise(axios.delete("/marketsgateway/v1/account/" + params.accountId + "/notification", { data: JSON.stringify(deletedRecipients) })).catch(error => {
            dispatch(onError(error.response));
        });
    }

    return (
        <main className={classes.layout}>
            <NotificationList notificationItems={[{ fieldName: "sendDaGenerationOfferEmail", tableLabel: "DA Generation Offer Email" },
            { fieldName: "sendDaLoadOfferEmail", tableLabel: "DA Load Offer" },
            { fieldName: "sendDaGenerationClearingEmail", tableLabel: "DA Generation Clearing" },
            { fieldName: "sendDaLoadClearingEmail", tableLabel: "DA Load Clearing" }]}
                recipients={{ ...recipients }} retrieveDistributionList={retrieveNotificationList} deleteRecipients={deleteRecipients}
                saveRecipients={saveDistributionList} />
        </main>
    )

}

export default MarketNotificationList;